import { Stack } from '@mantine/core'
import { LineNumberTable } from '@/components/speci/line-number-table/line-number-table'
import { StationContractsTable } from '@/components/speci/station-contracts-table/station-contracts-table'
import { ListContractDetailsForSeasonGql } from '@/graphql/queries/speci/list-contract-details-for-season.graphql'
import { useParams } from 'react-router-dom'
import { useAuthenticatedGraphQuery } from '@/hooks/use-authenticated-query'
import { UnprocessedWoolOnHoldTable } from '@/components/speci/unprocessed-wool-on-hold-table/unprocessed-wool-on-hold-table'
import { ListUnprocessedLotsGql } from '@/graphql/queries/speci/list-unprocessed-lots.graphql'

export function EditSpeciSidebar() {
  const { stationRecordNumber } = useParams()

  // Fetch the station contract details data
  const { data: contractsData } = useAuthenticatedGraphQuery({
    queryKey: ['listContractDetailsForSeason', stationRecordNumber],
    gql: ListContractDetailsForSeasonGql,
    queryParams: { stationRecordNumber },
  })

  // Fetch the unprocessed wool data
  const { data: unprocessedWoolData } = useAuthenticatedGraphQuery({
    queryKey: ['listUnprocessedLots', stationRecordNumber],
    gql: ListUnprocessedLotsGql,
    queryParams: { stationRecordNumber },
  })

  return (
    <Stack>
      <StationContractsTable contracts={contractsData?.listContractDetailsForSeason ?? []} />
      <UnprocessedWoolOnHoldTable data={unprocessedWoolData?.listUnprocessedLots ?? []} />
      <LineNumberTable />
    </Stack>
  )
}
